module.exports = __webpack_public_path__ + "static/media/6.4025aef1.svg";